import React from "react";
import { DatePicker, Tooltip } from "antd";
import { GlobalOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 加载dayjs插件
dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * UTC日期选择器组件
 * 强制以UTC时区显示和处理日期
 * 无论用户当前系统时区如何，输入和输出都是UTC时区
 */
const UTCDatePicker = ({ value, onChange, format = "YYYY-MM-DD", style, placeholder, disabled, ...restProps }) => {
    // 将value转换为UTC dayjs对象
    const utcValue = value ? dayjs.utc(value) : null;

    // 处理日期变更
    const handleChange = (date, dateString) => {
        if (!date) {
            onChange(null, '');
            return;
        }

        // 强制将选择的日期解释为UTC时区
        const year = date.year();
        const month = date.month();
        const day = date.date();
        // 使用这些值创建真正的UTC日期（不带时区偏移）
        const utcDate = dayjs.utc().year(year).month(month).date(day).hour(0).minute(0).second(0).millisecond(0);
        const utcDateString = utcDate.format(format);
        onChange(utcDate, utcDateString);
    };

    return (
        <Tooltip title="此日期以UTC时区解释">
            <DatePicker value={utcValue} onChange={handleChange} format={format} style={{ width: "100%", ...style }} placeholder={placeholder || "选择日期(UTC)"} disabled={disabled} suffixIcon={<GlobalOutlined style={{ color: "#1890ff" }} />} {...restProps} />
        </Tooltip>
    );
};

export default UTCDatePicker;
